import useCreateNeedFormDialog from 'react-components/dialog-forms/hooks/use-create-need-form-dialog';
import useRichMessageDialog from 'react-components/dialog-forms/hooks/use-rich-message-dialog';
import LearnMoreContent from './learn-more-content';
import { selectSelectedMember } from 'redux/slices/memberSlice';
import { useAppSelector } from 'redux/store-hooks';
import { InfoBox } from '@act/storybook';

const NeedsInfoCard = () => {
  const openLearnMoreDialog = useRichMessageDialog();
  const openCreateNeedFormDialog = useCreateNeedFormDialog();

  const memberIsIndependent =
    useAppSelector(selectSelectedMember)?.memberStage?.key === 'independence';

  return (
    <InfoBox
      iconName="HandHeart"
      title="How to meet member needs"
      content="Recognizing and addressing unmet needs positively impacts members’
          lives in any of three wellness domains (Health, Basic needs, and
          Economic stability)."
      actions={[
        {
          label: 'Learn more',
          onClick: () =>
            openLearnMoreDialog({
              title: 'Learn more',
              content: <LearnMoreContent />,
            }),
          trackingTag: 'needs-info-learn-more',
        },
        {
          label: 'Add need',
          onClick: () => openCreateNeedFormDialog({}),
          disabled: memberIsIndependent,
          iconName: 'Plus',
          trackingTag: 'needs-info-add-need',
        },
      ]}
    />
  );
};

export default NeedsInfoCard;
